<template>
    <div
        class="h3 text-left text-truncate"
        :class="!plotCounter ? 'my-auto' : null"
    >
        <div
            v-if="floorText"
            class="font-weight-black"
        >
            {{ floorText }}
        </div>
        <div
            v-if="plotCounter !== null"
            class="habiteo-body-2 text-truncate"
        >
            <span class="font-weight-bold">
                {{ plotCounter + ' ' + resultText + '' }}
            </span>
            <span
                v-if="floorText"
                class="ml-1"
            >
                {{ $t('cutawayHeader.searchResult.onThisFloor') }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PlotCounter',
        props: {
            plotCounter: {
                type: Number
            },
            floorText: {
                type: String
            }
        },
        computed: {
            resultText() {
                return this.plotCounter > 0 ? this.$t('cutawayHeader.searchResult.moreThanOne') : this.$t('cutawayHeader.searchResult.oneResult');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/cutawayHeader/components/PlotCounter.vue